import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      if (route.data['openInNewTab'] === true) {
        window.open(route.data['externalUrl'], '_blank');
      } else {
        window.location.href = route.data['externalUrl'];
      }
      return false;
  }
}
